module.exports = __webpack_public_path__ + "static/media/5.0a82e6d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格选中态/5.png
// module id = 953
// module chunks = 0